import { axios } from '@/api/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  MachineCreateModel,
  MachineUpdateModel,
  MachineUpdateSchema,
} from './mutation.schema'

export async function createMachine(data: MachineCreateModel): Promise<void> {
  await axios.post('/api/masterdata/machines', data)
}

export const useCreateMachineMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createMachine,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['machines'] })
    },
  })
}

export async function updateMachine(data: MachineUpdateModel): Promise<void> {
  const patch = MachineUpdateSchema.parse(data)
  await axios.put(`/api/masterdata/machines/${data.id}`, patch)
}

export const useUpdateMachineMutation = (id: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['machines', 'update', id],
    mutationFn: updateMachine,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['machines'] })
    },
  })
}

// =================  delete party =================

export const useDeleteMachineMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => axios.delete(`/api/masterdata/machines/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['machines'] })
    },
  })
}
